// S · Stuck. Phone v2 (11-03): Stuck is talked through in chat (her reasons card, then the help that fits), so the
// QS1 panel is gone. S stays as a route for old links and notifications: it starts the stuck talk for the card
// (params.cur, else the next card to do) and replaces itself with C.
import { useEffect } from 'preact/hooks';
import { useApp, stuckChat } from '../../store';
import { replace, useParams } from '../../router';

export function StuckScreen() {
  const st = useApp((x) => x.state);
  const params = useParams();
  useEffect(() => {
    if (!st) return;
    const todo = st.plan.cards.filter((x) => x.st === 'todo');
    const card = todo.find((x) => x.id === params.cur) || todo[0] || null;
    if (card) void stuckChat(card.id);
    replace('C', { cur: null, alt: null });
  }, [!!st]);
  return null;
}
